// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_LiabilityV1GetsafeAt = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  tariff_line: z.enum(['comfort']),
  family_status: z.enum(['single', 'partner_or_family']),
  drones_coverage: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  insured_sum_amount: z.coerce
    .string()
    .pipe(z.enum(['5000000', '20000000']))
    .pipe(z.coerce.number()),
  number_of_previous_claims: z.coerce
    .string()
    .pipe(z.enum(['0', '1']))
    .pipe(z.coerce.number())
    .optional(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
})

const Schema_LiabilityV1GetsafeAt = BaseSchema_LiabilityV1GetsafeAt

export default Schema_LiabilityV1GetsafeAt
